import { render, staticRenderFns } from "./NeoparentHospitalInfo.vue?vue&type=template&id=035157b0&scoped=true"
import script from "./NeoparentHospitalInfo.vue?vue&type=script&lang=js"
export * from "./NeoparentHospitalInfo.vue?vue&type=script&lang=js"
import style0 from "./NeoparentHospitalInfo.vue?vue&type=style&index=0&id=035157b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035157b0",
  null
  
)

export default component.exports